import React from 'react';

const SelectedTopicLayersPlaceholder = () => {
  return (
    <ul className="generic-list">
      {Array.from({ length: 3 }, (_, i) => (
        <li key={`topiclayer-placeholder${i}`} className="result-item__placeholder">
          <div className="text__placeholder shimmer" />
          <div className="text__placeholder--small shimmer" />
          <div className="text__placeholder shimmer" />
        </li>
      ))}
    </ul>
  );
};

export default SelectedTopicLayersPlaceholder;
